<template>
  <!-- 数组件 -->
  <div class="tree-box container">
    <div
      class="item f-13"
      :class="{ active: selectedIndex == index }"
      v-for="(item, index) in list"
      :key="index"
      @click.stop="openChild(item, index)"
    >
      <el-collapse
        v-if="item.children && item.children.length"
        style="border: unset;"
      >
        <el-collapse-item :title="item.name" :name="index">
          <my-tree :list="item.children" v-on="$listeners" />
        </el-collapse-item>
      </el-collapse>
      <router-link :to="detailPage(item, index)" v-else>
        <span class="item-name">{{ item.name }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyTree',
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      selectedIndex: -1,
      showChild: false,
    }
  },
  inject: ['args'],
  computed: {
    iconName() {
      let txt = ' el-icon-arrow-down'
      if (!this.showChild) {
        txt = 'el-icon-arrow-right'
      }
      return txt
    },
  },
  methods: {
    openChild(item, index) {
      this.selectedIndex = index
      if (!(item.children && item.children.length)) {
        // 关闭弹窗
        this.$emit('close', false)
        return
      }
      this.showChild = !this.showChild
    },
    detailPage(item, index) {
      if (item.pathName) {
        let args = {
          id: item.id,
          query: {
            index: index,
            page: 1,
            pageSize: this.args.pageSize,
            total: this.args.total,
          },
        }
        return {
          name: item.pathName,
          params: { args: JSON.stringify(args) },
        }
      }
      if (item.path) {
        if (item.path == '/home') {
          return { path: item.path, query: { type: item.name } }
        }
        return item.path
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tree-box {
  .item {
    border-bottom: 1px solid #ebeef5;

    line-height: 30px;
  }
  .active > a span {
    color: #257661;
  }
  .item a {
    text-decoration: none;
    color: #303133;
  }
  /deep/ {
    .el-collapse-item__header {
      line-height: 30px;
      height: unset;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tree/index.vue